import React, { useState, useContext } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Fab from "@mui/material/Fab";
import { Link } from "react-router-dom";
import ContactsIcon from "@mui/icons-material/Contacts";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";
import { Box, Modal, Typography } from "@mui/material";
import DoctorDetails from "./DoctorDetails";
import DeleteDoctor from "./DeleteDoctor";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const DoctorRow = (props) => {
  const clickHandler = () => {
    console.log(props.id);
  };
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  return (
    <React.Fragment>
      <Modal open={open1} onClose={handleClose1}>
        <Box sx={style}>
          <DoctorDetails
            id={props.id}
            name={props.name}
            contactNumber={props.contactNumber}
            email={props.email}
            address={props.address}
            token={props.token}
            close={handleClose1}
            open={open1}
          />
        </Box>
      </Modal>
      <Modal open={open2} onClose={handleClose2}>
        <Box sx={style}>
          <DeleteDoctor id={props.id} close={handleClose2} />
        </Box>
      </Modal>
      <TableRow hover="true">
        <TableCell align="justify">
          <Fab color="primary" size="small" onClick={handleOpen1}>
            <EditIcon />
          </Fab>
          <Fab
            color="secondary"
            size="small"
            style={{ marginRight: "1rem" }}
            onClick={handleOpen2}
          >
            <DeleteIcon id={props.id} />
          </Fab>
        </TableCell>
        <TableCell align="center">{props.name}</TableCell>
        <TableCell align="center">{props.contactNumber}</TableCell>
        <TableCell align="center">{props.email}</TableCell>
      </TableRow>
      <TableRow></TableRow>
    </React.Fragment>
  );
};
export default DoctorRow;
